import { ChevronDown, MousePointerClick } from "lucide-react";
import type { DayContent } from "../types";

interface Props {
  day: DayContent;
  step: number;
  onAdvance: () => void;
  onContinue: () => void;
}

export function IntroScene({ day, step, onAdvance, onContinue }: Props) {
  return (
    <section className="intro-scene" aria-label="פתיחת הסיפור">
      <img src="/assets/avi-rivka-intro.jpeg" alt="אבי ורבקה הולכים יחד ומחייכים" />
      <div className="intro-vignette" aria-hidden="true" />
      <button type="button" className="speech speech-avi visible" onClick={onAdvance} disabled={step > 0} aria-label={`לחצי על הבועה: ${day.speechBubble}`}>
        <span>{day.speechBubble}</span>
        {step === 0 && <small><MousePointerClick aria-hidden="true" /> לחצי כאן</small>}
      </button>
      {step >= 2 && (
        <div className="greeting-overlay" role="status">
          <p>{day.openingText}</p>
          <button className="scroll-button" onClick={onContinue} aria-label="המשיכי אל האור">
            <ChevronDown aria-hidden="true" />
          </button>
        </div>
      )}
    </section>
  );
}
